class FavMarquee extends HTMLElement {
    // TODO start marquee after all styles are loaded
  constructor() {
    super();
    this.items = this.querySelectorAll('.item');
    this.wrapper = this.querySelector('.wrapper');
    if(this.items.length == 0) {
        return
    }
    
    document.addEventListener('DOMContentLoaded', this.initialize.bind(this))
  }
  
  initialize() {
    
    this.width = 0
    this.items.forEach((item)=>{
        this.width += item.offsetWidth
    })

    for(let i = 0; i < 10; i++) {
        this.items.forEach((item)=>{
            const clone = item.cloneNode(true)
            this.wrapper.appendChild(clone)
        })
    }
    this.wrapper.style.setProperty('--animation-width', '-' + this.width + 'px');
    this.factor = this.width / 300
    this.speed = this.dataset.speed * this.factor;
    this.wrapper.style.animationDuration = this.speed + 's'
    this.classList.add('active')
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('fav-marquee', FavMarquee);

class VariantGroups extends HTMLElement {
    constructor() {
        super();
        // this.items = this.querySelectorAll('.item');
        this.radios = this.querySelectorAll('.item input[type="radio"][name="product"]');
        if(this.radios.length == 0) {
            return
        }
        this.rcRadios = this.querySelectorAll('.item input[type="radio"].rc_radio');
        this.rcSelects = this.querySelectorAll('.item .rc_select__frequency');
        
        document.addEventListener('DOMContentLoaded', this.initialize.bind(this))
      }

    initialize() {
        this.radios.forEach((radio)=>{
            radio.addEventListener('change', this.onVariantChange.bind(this))
        })
        // if(this.rcRadios.length > 0) {
        //     this.rcRadios.forEach((radio)=>{
        //         radio.addEventListener('change', this.onRcChange.bind(this))
        //     })
        // }
        // if(this.rcSelects.length > 0) {
        //     this.rcSelects.forEach((select)=>{
        //         select.addEventListener('change', this.onRcSelectChange.bind(this))
        //     })
        // }
    }
    
    onRcSelectChange(event) {
        const selectedValue = event.target.querySelector('option:checked').dataset.value
        this.rcSelects.forEach((otherSelect)=>{
            otherSelect.value = otherSelect.querySelector(`option[data-value="${selectedValue}"]`).value
        })
        document.querySelector(`#product-form-${this.dataset.section} [name="selling_plan"]`).value = event.target.value
    }
    
    onRcChange(event) {
        this.rcRadios.forEach((otherRadio)=>{
            if(otherRadio.value == event.target.value) {
                otherRadio.checked = event.target.checked
            }
        })
        if(event.target.value == 'autodeliver') {
            //let rcVariantId = document.querySelector(`#product-form-${this.dataset.section} [name="id"]`).dataset.subscriptionId
            let variantId = document.querySelector(`#product-form-${this.dataset.section} [name="id"]`).dataset.variantId
            let productId = document.querySelector(`#product-form-${this.dataset.section} [name="id"]`).dataset.productid
            document.querySelector(`#product-form-${this.dataset.section} [name="id"]`).value = variantId
            document.querySelector(`#product-form-${this.dataset.section} input[name="selling_plan"]`).removeAttribute('disabled')
            // document.querySelector(`#product-form-${this.dataset.section} [name="selling_plan"]`).value = event.target.value
            document.querySelector(`#shopify-section-${this.dataset.section} input[name="selling_plan"]`).value = document.querySelector(`#shopify-section-${this.dataset.section} .rc_select__frequency[data-product-id="${productId}"]`).value;
        } else {
            let variantId = document.querySelector(`#product-form-${this.dataset.section} [name="id"]`).dataset.variantId
            document.querySelector(`#product-form-${this.dataset.section} [name="id"]`).value = variantId
            document.querySelector(`#product-form-${this.dataset.section} input[name="selling_plan"]`).setAttribute('disabled', 'disabled')
        }
    }

    onVariantChange() {
        // this.updateOptions();
        this.updateMasterId()
        this.toggleAddButton(true, '');
        // this.updatePickupAvailability();
        // this.removeErrorMessage();
        // this.updateVariantStatuses();
        
        if (!this.currentProduct) {
            this.toggleAddButton(true, '');
            //   this.setUnavailable();
        } else {
            // this.updateMedia()
            this.updateURL()
            this.updateVariantInput();
            this.renderProductInfo();
            this.renderRecommendedProducts();
            this.renderFunckySection();
            //   this.updateShareUrl();
        }
    }
    
    updateMasterId() {
        const variantId = null
        this.radios.forEach((radio)=>{
            if(radio.checked) {
                this.currentProduct = this.getProductData(radio.value)
            }
        })
        // this.currentVariant = this.getVariantData().find((variant) => {
        //   return !variant.options
        //     .map((option, index) => {
        //       return this.options[index] === option;
        //     })
        //     .includes(false);
        // });
    }

    updateURL() {
        if (!this.currentProduct) return;
        window.history.replaceState({ }, '', `${window.routes.root_url}products/${this.currentProduct.handle}`);
        let event = new Event("product-url-change", {bubbles: true});
        document.body.dispatchEvent(event);
    }

    getProductData(productId) {
        this.currentProduct = JSON.parse(this.querySelector(`[type="application/json"][id="json_${productId}"]`).textContent);
        return this.currentProduct;
    }

    toggleAddButton(disable = true, text) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        productForm.dataset.productid = this.currentProduct.id
        productForm.dataset.smartrrFormId = this.currentProduct.id
        productForm.querySelector('input[data-productid]').dataset.productid = this.currentProduct.id
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
    
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (text) addButtonText.textContent = text;
          else addButtonText.textContent = window.variantStrings.addToCart;
        }
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[data-productid]');
            if(input) {
                input.value = this.currentProduct.variants[0].id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            const inputTry = productForm.querySelector('.try-before');
            if(inputTry) {
                inputTry.value = this.currentProduct.try_before;
                inputTry.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    renderFunckySection() {
        const requestedProductId = this.currentProduct;
        const url = `${window.routes.root_url}products/${requestedProductId.handle}`;
        console.log(url);
        document.querySelector('funky-img-accordion')?.renderSection(url);
    }
    
    renderProductInfo() {
        const requestedProductId = this.currentProduct;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const sectionIdClean = sectionId.replace(/\_\_main/,'')
    
        fetch(
          `${window.routes.root_url}products/${this.currentProduct.handle}?section_id=${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentProduct !== requestedProductId) return;
            
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.getElementById(`price-${this.dataset.section}`);
            const source = html.getElementById(
                `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const skuSource = html.getElementById(
                `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            const inventorySource = html.getElementById(
                `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
            const formSource = html.getElementById(
                `Form-container-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const formDestination = document.getElementById(`Form-container-${this.dataset.section}`);
            const smartrrSource = html.getElementById(
                `Smartrr-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const smartrrDestination = document.getElementById(`Smartrr-${this.dataset.section}`);

            document.querySelectorAll(`[data-smartrr-product-id]`).forEach((button) => {
                button.setAttribute('data-smartrr-product-id', this.currentProduct.id);
            });    
                    
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (formSource && formDestination) formDestination.classList = formSource.classList;
            if (smartrrSource && smartrrDestination) smartrrDestination.innerHTML = smartrrSource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
            }

            const legendDest = document.querySelector('.product-form__input legend');
            const legendSource = html.querySelector('.product-form__input legend');
            if (legendDest && legendSource) {
                legendDest.innerHTML = legendSource.innerHTML;
            }
    
            const price = document.getElementById(`price-${this.dataset.section}`);
    
            if (price) price.classList.remove('visibility-hidden');
    
            if (inventoryDestination)
              inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

            // DedCool
            const infoWrapperDestination = document.querySelector(`#shopify-section-${this.dataset.section} .product__info-wrapper`);
            const infoWrapperSource = html.querySelector(
                `#shopify-section-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} .product__info-wrapper`
            );
            if (infoWrapperDestination && infoWrapperSource) infoWrapperDestination.innerHTML = infoWrapperSource.innerHTML;
            yotpoWidgetsContainer.initWidgets();

            const mediaWrapperDestination = document.querySelector(`#shopify-section-${this.dataset.section} .product__media-wrapper`);
            const mediaWrapperSource = html.querySelector(
                `#shopify-section-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} .product__media-wrapper`
            );
            if (mediaWrapperDestination && mediaWrapperSource) mediaWrapperDestination.innerHTML = mediaWrapperSource.innerHTML;
            const swiperThumbs = new Swiper(`#shopify-section-${this.dataset.section} .product__media-wrapper .swiper.thumbnails`, {
                slideToClickedSlide:true,
                direction: 'horizontal',
                //loop: true,
                //loopAdditionalSlides:4,
                slidesPerView: 4.6,
                threshold: 10,
                spaceBetween : 9,
                slideToClickedSlide:true,
                breakpoints: {
                    769: {
                        spaceBetween : 6,
                        slidesPerView: 'auto',
                        direction: 'vertical',  
                    }
                }
            });
            const swiper = new Swiper(`#shopify-section-${this.dataset.section} .product__media-wrapper .swiper.images`, {
                direction: 'horizontal',
                slidesPerView: 1,
                spaceBetween : 0,
                threshold: 10,
                slideToClickedSlide:true,
                thumbs: {
                    swiper: swiperThumbs
                },
                navigation: {
                    nextEl: `.swiper-button-next-${this.dataset.section}`,
                    prevEl: `.swiper-button-prev-${this.dataset.section}`,
                }
            });
            const inputDestination = document.querySelector(`#shopify-section-${this.dataset.section} [name="id"]`);
            const inputSource = html.querySelector(
                `#shopify-section-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} [name="id"]`
            );
            if (inputDestination && inputSource && document.querySelector(`#shopify-section-${this.dataset.section} [name="product"][type="radio"]:checked`).parentElement.querySelector('[type="radio"][value="autodeliver"]')) {
                if(document.querySelector(`#shopify-section-${this.dataset.section} [name="product"][type="radio"]:checked`).parentElement.querySelector('[type="radio"][value="autodeliver"]').checked) {
                    // inputDestination.value = inputSource.dataset.subscriptionId
                    inputDestination.value = inputSource.dataset.variantId
                    document.querySelector(`#shopify-section-${this.dataset.section} input[name="selling_plan"]`).value = document.querySelector(`#shopify-section-${this.dataset.section} .rc_select__frequency[data-product-id="${inputSource.dataset.productid}"]`).value;
                } else {
                    inputDestination.value = inputSource.dataset.variantId
                }
                inputDestination.dataset.subscriptionId = inputSource.dataset.subscriptionId;
                inputDestination.dataset.variantId = inputSource.dataset.variantId;
            }

            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            const isDisabled = addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true
            this.toggleAddButton(
              isDisabled,
              isDisabled ? window.variantStrings.soldOut : addButtonUpdated.querySelector('span')?.textContent
            );
    
            publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                  sectionId,
                  html,
                  variant: this.currentProduct.variants[0],
                },
            });
              
            document.dispatchEvent(
                new CustomEvent('smartrrReload', {
                  detail: {
                    product: this.currentProduct,
                  },
                })
              );
            fetch(
                `${window.routes.root_url}products/${this.currentProduct.handle}?section_id=${sectionIdClean}__product-reviews`
                )
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    // DedCool
                    const infoWrapperDestination = document.querySelector(`#shopify-section-${sectionIdClean}__product-reviews`);
                    const infoWrapperSource = html.querySelector(
                        `#shopify-section-${sectionIdClean}__product-reviews`
                    );
                    if (infoWrapperDestination && infoWrapperSource) infoWrapperDestination.innerHTML = infoWrapperSource.innerHTML;
                    dispatchEvent(new Event('load'));
                })
        });
    }
    renderRecommendedProducts() {
        const id = document.querySelector('.section-product-recommendations')?.id?.replace('shopify-section-', '') ?? null;

        fetch(
          `${window.routes.root_url}products/${this.currentProduct.handle}?section_id=${id}`
        )
          .then((response) => response.text())
          .then((responseText) => {

            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const infoWrapperDestination = document.querySelector(`#shopify-section-${id}`);
            const infoWrapperSource = html.querySelector(
                `#shopify-section-${id}`
            );
            if (infoWrapperDestination && infoWrapperSource) infoWrapperDestination.innerHTML = infoWrapperSource.innerHTML;
            dispatchEvent(new Event('load'));
          })
    }
}

customElements.define('variant-groups', VariantGroups);